import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';
import { Droplets } from 'lucide-react';

export class LubeProductSalesSummary extends Component {
  constructor() {
    super();
    this.state = {
      tab: 1,
    };
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header>
            <Droplets color="#31af36" />
            <h3>Lube / Product sales summary</h3>
          </header>
          <main>
            <table className="dsr" data-name="Lube & Product sales summary">
              <thead>
                <tr data-header={true}>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((item, i) => (
                  <tr key={i}>
                    <td>{item.product}</td>
                    <td>{item.total_sale_in_liters.toFixed(2)}</td>
                    <td> {formatCurrency(item.total_sale_value || 0)} </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
